export default { sha: 'bae6b0ddcf71d2629ab44048799b22a6a7e1cad0', buildNumber: 'undefined' }
